import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import DataFormTitleWithRedirect from 'components/DataFormTitleWithRedirect';
import TabsMaterial from 'components/TabsMaterial';
import { tabsList } from './listTabsflag';
import LinkFormTitleWithRedirect from 'components/LinkFormTitleWithRedirect';

export interface DataFormProps {
	name: string;
	height: string;
	padding_left: number;
	padding_right: number;
	padding_top: number;
	padding_bottom: number;
	border_left: number;
	border_right: number;
	border_top: number;
	border_bottom: number;
	countdown: boolean;
	schedule_end: string;
	schedule_start: string;
	type: string;
	color: string;
	weight: string;
	link: {
		name: string;
		redirect_type: string;
		redirect_value: string;
		weight: null | string;
		facets: string;
		color: string;
	};
}

const initialState: DataFormProps = {
	name: '',
	height: '',
	padding_left: 0,
	padding_right: 0,
	padding_top: 0,
	padding_bottom: 0,
	border_left: 0,
	border_right: 0,
	border_top: 0,
	border_bottom: 0,
	countdown: false,
	schedule_end: '',
	schedule_start: '',
	type: '',
	color: '#000',
	weight: '',
	link: {
		name: '',
		redirect_type: '',
		redirect_value: '',
		weight: null,
		facets: '',
		color: '#000'
	}
};

export default function InputsTitleWithRedirect() {
	const [tabSelected, setTabSelected] = useState(0);
	const [dataForm, setDataForm] = useState<DataFormProps>(initialState);

	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: { ...dataForm } };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: { ...dataForm } };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		setTimeout(() => {
			if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}
		}, 100);
	}, []);

	return (
		<S.container>
			<TabsMaterial listTabs={tabsList} getPage={setTabSelected} />

			<DataFormTitleWithRedirect
				isShow={tabSelected === 0}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>

			<LinkFormTitleWithRedirect
				isShow={tabSelected === 1}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>
		</S.container>
	);
}
